<template>

  <div>

    <EnterpriseContentDialog :command="command"
                           :foreign-key="foreignKey"
                           :primary-key="form.enterpriseContentId"
                           @onSubmit="onEnterpriseContentDialog"/>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="enterpriseContentId"
                 :primary-key="form.enterpriseContentId"
                 :foreign-key-column="foreignKeyColumn"
                 :foreign-key="foreignKey"
                 sortable
                 enable-change-order-up-down
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit" @onItemRead="onContentReadItem" @onItemDelete="onItemDeleteDefault">

      <div class="ml-1 mb-3">

        <t-button @click="openContentInsert">
          <b-icon-plus-circle/>
          {{ t('insert') + ' Conteúdo' }}
        </t-button>

      </div>

      <t-input v-model="form.enterpriseContentId" hidden/>

      <template #item(typeContent)="{item}">

        <div v-if="item.typeContent === ContentType.type.BEFORE">Início</div>
        <div v-else>Fim</div>
      </template>

    </t-form-list>

  </div>

</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import ContentType from "@/model/types/resource/ContentType";
import EnterpriseContentDialog from "@/views/modules/place/EnterpriseContentDialog";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList, EnterpriseContentDialog},
  name: 'EnterpriseContent',
  data() {
    return {
      ContentType,
      path: "place/enterprise-content", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "enterpriseId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "enterpriseContentId", keyDelete: "enterpriseContentId"},
        {key: "typeContent", label: "Tipo", cols: "1", formatter: ""},
        {key: "title", label: "Título", cols: "3"},
        {key: "content", label: "Conteúdo", cols: "3"},
        {key: "qtyPhotos", label: "Qtd. Fotos.", cols: "2", formatter: "number"},

      ],
      form: {
        enterpriseId: this.foreignKey,
        enterpriseContentId: 0,
        title: "",
        content: "",
        typeContent: ContentType.type.BEFORE,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        enterpriseContentId: "",
      },
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {


    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.enterpriseContentId)


    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openContentInsert() {
      this.form.enterpriseContentId = 0
      this.command = 'insert'
      this.openDialogForm('modal-enterprise-content-dialog')
    },
    onContentReadItem(id) {
      this.form.enterpriseContentId = id
      this.command = 'update'
      this.openDialogForm('modal-enterprise-content-dialog')
    },

    async onEnterpriseContentDialog() {

      //Atualiza a listagem
      await this.getList()

    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
